module.exports = __webpack_public_path__ + "img/swiper5.7dee004e.png";